import { render, staticRenderFns } from "./UserProfileJumbo.vue?vue&type=template&id=459ef481&scoped=true"
import script from "./UserProfileJumbo.vue?vue&type=script&lang=js"
export * from "./UserProfileJumbo.vue?vue&type=script&lang=js"
import style0 from "./UserProfileJumbo.vue?vue&type=style&index=0&id=459ef481&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ef481",
  null
  
)

export default component.exports